<template>
  <GSToast :show="show" @clicked="clicked()">
    <div slot="content">
      <div class="icon">
      <img
        v-if="hasIcon"
        :src="iconUrl"
      />
      </div>
      <div class="text" v-text="text"></div>
    </div>
  </GSToast>
</template>

<script>
import GSToast from './GSToast'
import { EVENT } from '@/constants/event'

export default {
  name: 'GSToastWarn',
  props: {
    type: {
      type: String,
      default: null
    },
    text: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasIcon () {
      return !!this.type
    },
    iconUrl () {
      switch (this.type) {
        case 'warn':
          return 'https://cdngarenanow-a.akamaihd.net/webmain/static/game_service/bind/icon_warnning.png'
      }
      return ''
    }
  },
  methods: {
    clicked () {
      this.$emit(EVENT.CLICKED)
    }
  },
  components: {
    GSToast
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/vars/base';

.icon {
  display: inline;
  position: relative;
  width: $base-size * 38;

  img {
    width: $base-size * 36;
    position: absolute;
    top: 0;
  }
}

.text {
  display: inline;
  margin-left: $base-size * 55;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/GSToastWarn.vue